"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CubeJSClient = void 0;
const core_1 = __importDefault(require("@cubejs-client/core"));
const filter_builder_1 = require("@segmentstream/filter-builder");
const p_queue_1 = __importDefault(require("p-queue"));
class CubeJSClient {
    constructor(apiUrl, jwtToken, concurrency = 50) {
        this.mutexObj = {};
        this.client = (0, core_1.default)(jwtToken, { apiUrl: `${apiUrl}/cubejs-api/v1` });
        this.pQueue = new p_queue_1.default({ concurrency });
    }
    clearFilters(filters) {
        return filters.map(filter => {
            if ((0, filter_builder_1.isOrFilter)(filter)) {
                return {
                    or: this.clearFilters(filter.or),
                };
            }
            if ((0, filter_builder_1.isAndFilter)(filter)) {
                return {
                    and: this.clearFilters(filter.and),
                };
            }
            if ((0, filter_builder_1.isUnaryFilter)(filter)) {
                return Object.assign(Object.assign({}, (filter.member ? { member: filter.member } : {})), (filter.operator ? { operator: filter.operator } : {}));
            }
            return Object.assign(Object.assign(Object.assign({}, (filter.member ? { member: filter.member } : {})), (filter.operator ? { operator: filter.operator } : {})), (filter.values ? { values: filter.values } : {}));
        });
    }
    async queryOneQuery(query, mutexKey, notPreaggregatedMeasure) {
        let notPreaggregatedResult;
        let filters = query.filters;
        if (filters) {
            filters = this.clearFilters(filters);
        }
        const result = await new Promise(async (resolve, reject) => {
            let continueWait = 0;
            const loadNotPreaggregatedResult = async () => {
                if (notPreaggregatedMeasure && !notPreaggregatedResult) {
                    console.log(`Trying to request without pre aggregation ${mutexKey || ''}`);
                    notPreaggregatedResult = this.client.load(Object.assign(Object.assign(Object.assign({}, query), (filters ? { filters } : {})), { measures: [
                            ...(query.measures || []).filter(measure => measure !== notPreaggregatedMeasure),
                            notPreaggregatedMeasure,
                        ] }), {
                        mutexKey,
                        mutexObj: this.mutexObj,
                    });
                    try {
                        resolve(await notPreaggregatedResult);
                    }
                    catch (e) {
                        reject(e);
                    }
                }
            };
            try {
                const res = await this.client.load(Object.assign(Object.assign({}, query), (filters ? { filters } : {})), {
                    mutexKey,
                    mutexObj: this.mutexObj,
                    // Function that receives `ProgressResult` on each `Continue wait` message.
                    progressCallback: () => {
                        continueWait += 1;
                        // We will be able to use it later
                        if (continueWait > 0) {
                            console.info(`Building pre-aggregations`);
                            return loadNotPreaggregatedResult();
                        }
                    },
                });
                resolve(res);
            }
            catch (e) {
                console.error(`Error while request query ${mutexKey || ''}`, e);
                await loadNotPreaggregatedResult();
            }
        });
        return result;
    }
    async query(preparedQuery) {
        const mutexKey = preparedQuery.mutexKey;
        const results = await this.pQueue.add(() => Promise.all(preparedQuery.queries.map((query, i) => {
            var _a;
            return this.queryOneQuery(query, mutexKey ? `${mutexKey}:${i}` : undefined, (_a = preparedQuery.notPreaggregatedMeasures) === null || _a === void 0 ? void 0 : _a[i]);
        })));
        return preparedQuery.resultProcessor(results);
    }
}
exports.CubeJSClient = CubeJSClient;
//# sourceMappingURL=client.js.map